import React, { FC, PropsWithChildren } from 'react'
import styles from './EmptyState.module.css'
import GradientText from '../gradient-text'
import classNames from 'classnames'

const EmptyState: FC<
	PropsWithChildren<{
		className?: string
		title?: string
		subtitle?: string
	}>
> = (props) => {
	const { className, title, subtitle } = props

	return (
		<div className={classNames({ [(props.className as any)]: !!className }, styles.root)}>
			{title && (
				<GradientText classNames={classNames(styles.title, 'display-lg', 'semibold')}>
					{title}
				</GradientText>
			)}
			{subtitle && (
				<div className={classNames(styles.subtitle, 'text-lg', 'regular')}>{subtitle}</div>
			)}
			{props.children}
		</div>
	)
}

export default EmptyState
